// @ts-nocheck
import { storeService } from '@/services';
export default {
    setStoreManagementFeeBySectionDialogOpen({ commit }, isOpen = true) {
        commit('SET_STORE_MANAGEMENT_FEE_BY_SECTION_DIALOG_OPEN', isOpen);
    },
    setStoreManagementFeeBySectionAddFeeSectionOpen({ commit }, isOpen = true) {
        commit('SET_STORE_MANAGEMENT_FEE_BY_SECTION_ADD_FEE_SECTION_OPEN', isOpen);
    },
    setSelectedStoreId({ commit }, storeId = '') {
        commit('SET_SELECTED_STORE_ID', storeId);
    },
    setEditFeeItem({ commit }, item = {}) {
        commit('SET_EDIT_FEE_ITEM', item);
    },
    // 상점 구간별 관리비 설정 (C,R,U,D)
    /**
     * 상점 구간별 관리비 설정 생성
     */
    async postStoreManagementFeeBySection({ commit }, payload) {
        const { storeId } = payload;
        const response = await storeService.postStoreManagementFeeBySection({
            storeId,
            payload,
        });
        commit('POST_STORE_MANAGEMENT_FEE_BY_SECTION', response.data);
    },
    /**
     * 상점 구간별 관리비 설정 조회
     */
    async getStoreManagementFeeBySection({ commit }, storeId) {
        const response = await storeService.getStoreManagementFeeBySection({
            storeId,
        });
        commit('GET_STORE_MANAGEMENT_FEE_BY_SECTION', response.data);
    },
    /**
     * 상점 구간별 관리비 설정 수정
     */
    async putStoreManagementFeeBySection({ commit }, payload = {}) {
        const { storeId, feeId } = payload;
        const response = await storeService.putStoreManagementFeeBySection({
            storeId,
            feeId,
            payload,
        });
        commit('PUT_STORE_MANAGEMENT_FEE_BY_SECTION', response.data);
    },
    /**
     * 상점 구간별 관리비 설정 삭제
     */
    async deleteStoreManagementFeeBySection({ state, commit }, payload = {}) {
        const { storeId, feeId } = payload;
        const response = await storeService.deleteStoreManagementFeeBySection({
            storeId,
            feeId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const updatedFeeList = state.storeManagementFeeBySectionList
            .filter((fee) => fee.id !== feeId);
        commit('DELETE_STORE_MANAGEMENT_FEE_BY_SECTION', updatedFeeList);
    },
    // 초기화
    clearStoreManagementFeeBySection({ commit }) {
        commit('CLEAR_STORE_MANAGEMENT_FEE_BY_SECTION');
    },
};
